export interface Row {
  clientId: string
  parentClientId: string | null
  kind: 'group' | 'position' | 'text' | 'discount'
  mode: 'mandatory' | 'optional' | 'alternative'
  itemCategory: 'material' | 'labor' | 'flat'
  description: string
  longText: string
  quantity: number
  unit: string
  unitPriceCents: number
  discountPercent: number
  alternativeGroup: string
  isChosenAlternative: boolean
  /** nur kind=discount: „von"-Grenze als numberLabel (leer ⇒ ab Anfang) */
  rangeFromLabel: string
  /** nur kind=discount: „bis"-Grenze als numberLabel (leer ⇒ bis hier) */
  rangeToLabel: string
  articleId: string | null
  /** nur Gutschriften: gutgeschriebene Position der Ursprungsrechnung (wird beim Bearbeiten durchgereicht) */
  creditedItemId?: string | null
  /** nur clientseitig für die Materialkosten-Vorschau — Server berechnet das beim Speichern neu. */
  purchasePriceCents: number | null
}

export function newRow(kind: Row['kind'], parentClientId: string | null): Row {
  return {
    clientId: `c_${Math.random().toString(36).slice(2)}`,
    parentClientId,
    kind,
    mode: 'mandatory',
    itemCategory: 'material',
    description: kind === 'discount' ? 'Rabatt' : '',
    longText: '',
    quantity: kind === 'discount' ? 0 : 1,
    unit: 'Stk.',
    unitPriceCents: 0,
    discountPercent: 0,
    alternativeGroup: '',
    isChosenAlternative: false,
    rangeFromLabel: '',
    rangeToLabel: '',
    articleId: null,
    purchasePriceCents: null,
  }
}

/** sortIndex je Zeile aus der Array-Reihenfolge innerhalb desselben Parents. */
export function toItemsPayload(rows: Row[]) {
  const counters = new Map<string, number>()
  return rows.map((r) => {
    const key = r.parentClientId ?? '__root__'
    const idx = counters.get(key) ?? 0
    counters.set(key, idx + 1)
    return {
      clientId: r.clientId,
      parentClientId: r.parentClientId,
      sortIndex: idx,
      kind: r.kind,
      itemCategory: r.itemCategory,
      description:
        r.description ||
        (r.kind === 'group'
          ? 'Gruppe'
          : r.kind === 'text'
            ? 'Text'
            : r.kind === 'discount'
              ? 'Rabatt'
              : 'Position'),
      longText: r.longText || null,
      quantity: r.quantity || 0,
      unit: r.unit || 'Stk.',
      unitPriceCents: Math.round(r.unitPriceCents || 0),
      discountPercent: r.discountPercent || 0,
      mode: r.mode,
      alternativeGroup: r.mode === 'alternative' ? r.alternativeGroup || 'A' : null,
      isChosenAlternative: r.mode === 'alternative' ? r.isChosenAlternative : false,
      rangeFromLabel: r.kind === 'discount' ? r.rangeFromLabel || null : null,
      rangeToLabel: r.kind === 'discount' ? r.rangeToLabel || null : null,
      articleId: r.articleId,
      creditedItemId: r.creditedItemId ?? null,
    }
  })
}
